import { useEffect } from 'react';

interface UsePopoverResizeObserverOptions {
  active: boolean;
  onHeightChange?: (height: number) => void;
  selector?: string;
}

export const usePopoverResizeObserver = ({
  active,
  onHeightChange,
  selector = '.Polaris-Popover__Content--fluidContent',
}: UsePopoverResizeObserverOptions) => {
  useEffect(() => {
    if (!active) return;

    let resizeObserver: ResizeObserver | null = null;
    const setupResizeObserver = () => {
      const popoverContent = document.querySelector(selector);
      if (popoverContent && !resizeObserver) {
        resizeObserver = new ResizeObserver((entries) => {
          for (const entry of entries) {
            const { height } = entry.contentRect;
            onHeightChange?.(height);
          }
        });

        resizeObserver.observe(popoverContent);
      }
    };
    setTimeout(() => {
      setupResizeObserver();
    }, 200);

    return () => {
      if (resizeObserver) {
        resizeObserver.disconnect();
        resizeObserver = null;
      }
    };
  }, [active, selector]);
};
